export default __webpack_public_path__ + "static/media/thumb02_invitation1@2x.1fa8cf71.png";